var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-members',{attrs:{"group":_vm.group,"role":_vm.role,"add-disabled":_vm.canAddAdmin,"show-email":""},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var users = ref.users;
return [_vm._v(" "+_vm._s(_vm.$t('groups.admins.title', _vm.getAdminCount(users)))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }